export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6716.3d34a585.jpg";